(function () {
  'use strict';

  var styleId = 'gtj-podium-bubble-styles';
  var internalCss = [
    '.ContactBubble{position:fixed!important;right:11px!important;bottom:12px!important;left:auto!important;top:auto!important;width:122px!important;height:48px!important;}',
    '.ContactBubble__Bubble{position:absolute!important;right:0!important;bottom:0!important;left:auto!important;top:auto!important;transform:none!important;background:#252525!important;box-shadow:0 4px 14px rgba(0,0,0,.18)!important;transition:background-color 180ms ease,box-shadow 180ms ease,transform 180ms ease!important;}',
    '.ContactBubble__TextUs span{font-size:15px!important;line-height:24px!important;font-weight:600!important;}',
    '.ContactBubble__Bubble:hover{background:#424242!important;box-shadow:0 7px 18px rgba(0,0,0,.24)!important;transform:translateY(-2px)!important;}',
    '.ContactBubble__Bubble:focus-visible{outline:2px solid #252525!important;outline-offset:3px!important;}',
    '@media(max-width:80px){.ContactBubble{right:2px!important;bottom:2px!important;width:52px!important;height:52px!important;}.ContactBubble__Bubble{width:52px!important;height:52px!important;min-width:52px!important;min-height:52px!important;padding:0!important;border-radius:50%!important;display:flex!important;align-items:center!important;justify-content:center!important;}.ContactBubble__TextUs{display:none!important;}.ContactBubble__IconContainer,.ContactBubble__Icon{margin:0!important;padding:0!important;display:flex!important;align-items:center!important;justify-content:center!important;position:static!important;}}',
    '@media(prefers-reduced-motion:reduce){.ContactBubble__Bubble{transition:none!important;}.ContactBubble__Bubble:hover{transform:none!important;}}'
  ].join('');

  function styleBubbleFrame() {
    var frame = document.getElementById('podium-bubble');
    if (!frame) return;
    try {
      var doc = frame.contentDocument;
      if (!doc || !doc.head) return;
      var style = doc.getElementById(styleId);
      if (!style) {
        style = doc.createElement('style');
        style.id = styleId;
        style.textContent = internalCss;
        doc.head.appendChild(style);
      }
    } catch (error) {
      /* Podium may change iframe isolation; parent placement remains effective. */
    }
  }

  var frame;
  var scheduled = false;
  var purchaseVisible = false;

  function setClass(name, value) {
    if (document.body.classList.contains(name) !== value) document.body.classList.toggle(name, value);
  }

  function updatePlacement() {
    scheduled = false;
    var stickyVisible = /(?:^|\s)(?!gtj-podium-)[\w-]+-sticky-buy-visible(?:\s|$)/.test(document.body.className);
    setClass('gtj-podium-purchase-visible', purchaseVisible);
    setClass('gtj-podium-sticky-buy-visible', stickyVisible);
    if (!frame) return;
    if (window.innerWidth <= 768) {
      var bottom = stickyVisible ? 'calc(85px + env(safe-area-inset-bottom))' : 'calc(16px + env(safe-area-inset-bottom))';
      if (frame.style.getPropertyValue('bottom') !== bottom || frame.style.getPropertyPriority('bottom') !== 'important') {
        frame.style.setProperty('bottom', bottom, 'important');
      }
    } else if (frame.style.getPropertyValue('bottom')) {
      frame.style.removeProperty('bottom');
    }
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updatePlacement);
  }

  function attachFrame() {
    var found = document.getElementById('podium-bubble');
    if (!found) return;
    if (frame !== found) {
      frame = found;
      frame.addEventListener('load', styleBubbleFrame);
    }
    styleBubbleFrame();
    scheduleUpdate();
  }

  function init() {
    var purchaseButton = document.querySelector('.product-single__form .add-to-cart, .product-single__form button[name="add"], .product-form button[name="add"], .cart__checkout, button[name="checkout"]');
    if (purchaseButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        purchaseVisible = entries[0].isIntersecting;
        scheduleUpdate();
      }).observe(purchaseButton);
    }
    new MutationObserver(scheduleUpdate).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('gtj:chat-ready', attachFrame);
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    attachFrame();
    scheduleUpdate();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());
